<template>
  <div class="unassigned-record">
    <!-- 转移&分配记录 -->
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.transferAllocationRecords')"></NavHeaderBar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="No more data" @load="onLoad" :immediate-check="false">
        <div class="activity-item" v-for="(item, index) in list" :key="index">
          <div class="header-info">
            <span class="item-time">{{ $t('shared.visitTime') }}: {{ item.localUpdateTime }}</span>
            <span class="item-name">{{ item.updateUserName }}</span>
          </div>
          <div class="item-body">
            <!-- 标记忽略本次转移&分配  -->
            <div v-if="item.status === -1" class="record-desc">{{ $t('shared.markToIgnoreThisTransferAllocation') }}</div>
            <!-- 将门店转移并分配给 -->
            <div v-else class="record-desc">{{ $t('shared.transferAndAssignStoresTo') }} {{ item.dutyUserName }}</div>
            <div class="store-info" @click="toPage(`/storeExpansion/storeMappingDetail?customerId=${item.customerId}`)">
              <img class="store-img" src="@/assets/images/store.png" alt="">
              <span class="store-name van-ellipsis">{{ item.customerName }}</span>
            </div>
          </div>
          <div class="oper-btn">
            <van-button plain type="primary" color="#555555" size="small" @click="toPage(`/storeExpansion/visitSellInDetail?visitId=${item.visitId}&pageType=unassignedStore`)">{{ $t('button.visitInfo') }}.</van-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { customerAllotLogListPageApi } from '@/api/unassignedStore'
export default {
  data () {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      page: 1,
      pageSize: 10
    }
  },
  activated () {
    this.page = 1
    // Initial load
    this.onLoad()
  },
  methods: {
    onRefresh () {
      this.finished = false
      this.loading = true
      this.page = 1
      this.onLoad()
    },
    onLoad () {
      // Mock API call
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }
      const data = {
        page: this.page,
        limit: 10
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      customerAllotLogListPageApi(data).then(res => {
        Toast.clear()
        if (this.page === 1) {
          this.list = res.data.list
        } else {
          this.list = [...this.list, ...res.data.list]
        }
        this.loading = false
        this.page++
        if (this.list.length >= Number(res.data.totalRow)) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    toPage (url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.unassigned-record {
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .activity-item {
    background-color: #fff;
    margin-bottom: 1px; // Divider effect
    border-bottom: 1px solid #f0f0f0;

    .header-info {
      display: flex;
      justify-content: space-between;
      padding: 12px 10px 10px 10px;
      border-bottom: 1px solid #f0f0f0;
      font-size: 13px;
      .item-time {
        color: #7f7f7f;
      }
      .item-name {
        color: #307bff;
      }
    }

    .item-body {
      padding: 10px;
      font-size: 13px;
      .record-desc {
        margin-bottom: 8px;
      }
      .store-info {
        display: flex;
        align-items: center;
        .store-img {
          width: 13px;
          height: 13px;
          margin-right: 6px;
        }
        .store-name {
          flex: 1;
          color: #307bff;
          text-decoration: underline;
        }
      }
    }
    .oper-btn {
      display: flex;
      justify-content: flex-end;
      padding: 10px;
      padding-top: 0;
      /deep/.van-button {
        height: 30px;
        width: 76px;
        border-radius: 5px;
        margin-left: 10px;
      }
    }
  }
}
</style>
